import { Reveal } from "./Reveal";

const steps = (chain) =>
  chain.map((s, i) => (
    <span key={i} className="flex items-center gap-3 sm:gap-4 shrink-0">
      <span className="font-mono text-xs sm:text-sm tracking-[0.15em] uppercase text-slate-200 whitespace-nowrap">{s}</span>
      {i < chain.length - 1 && <span className="text-sovereign" aria-hidden="true">→</span>}
    </span>
  ));

export default function DeliveryChain({ chain }) {
  return (
    <Reveal>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-3 sm:gap-x-6" data-testid="delivery-chain">
        {steps(chain)}
      </div>
    </Reveal>
  );
}
